import {
  Datagrid,
  EditButton,
  List,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  FunctionField,
} from 'react-admin';
import { Card, CardContent } from '@mui/material';
import { CustomActions, IndexField } from '../../components';

const ListUser = () => (
  <Card variant='elevation'>
    <CardContent>
      <List
        title="Cognito Users"
        actions={<CustomActions title="Manage Users" addBtnLabel="Add User" type="list" />}
      >
        <Datagrid rowClick="edit" size='medium' bulkActionButtons={false} sx={{ borderTop: '1px solid grey', maxHeight: '70vh', overflow: 'auto' }}>
          <FunctionField
            label='NO'
            render={(record) => <IndexField record={record} />}
          />
          <TextField source="name" label="NAME" sortable={false} />
          <TextField source="email" label="EMAIL" sortable={false} />
          <ReferenceManyField
            source="id"
            reference="cognitoGroups"
            target="listGroupsForUser.username"
            label="ROLES"
            sortable={false}
          >
            <SingleFieldList linkType=''>
              <FunctionField
                label="test"
                render={(record) => `${record.id}`}
                style={{ color: "white" }}
              />
            </SingleFieldList>
          </ReferenceManyField>
          <FunctionField
            label='ACTION'
            render={(record) => <EditButton label='' record={record} sx={{ color: 'white' }}/>}
          />
        </Datagrid>
      </List>
    </CardContent>
  </Card>
);

export default ListUser;
export { ListUser };